export default "__VITE_ASSET__BwdIOpQ6__"